import { useEffect, useState } from "react";
import logo from "../../assests/logo.jpg";
import API from "../../services/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function TopBar({ isLoggedIn }) {

    const [address, setAddress] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoggedIn) {
            fetchAddress();
        } else {
            setAddress(null)
        }
    }, [isLoggedIn, location]);

    const fetchAddress = async () => {
        try {
            const res = await API.get("/api/address/selected")
            setAddress(res.data)
        } catch (error) {
            console.log("ADDRESS ERROR : ", error)
        }
    }

    return (
        <section className="topbar">

            {/* LEFT SIDE */}
            <div className="topbar-left">
                <div className="brand-box" onClick={() => navigate("/")}>
                    <img src={logo} alt="Shopsphere Logo" className="logo-img" />
                    <span className="brand-name">ShopSphere</span>
                </div>
            </div>

            {/* RIGHT SIDE */}
            <div
                className="topbar-right location-box"
                onClick={() => navigate("/choose-location")}
            >
                <span className="icon"><FontAwesomeIcon icon={faLocationDot} /></span>
                <span className="address">
                    {address ? address.street : "Select Location"}
                </span>
            </div>

        </section>
    );
}

export default TopBar;